import MiForget from './forget';
import { install } from '../../utils/install';
export default install(MiForget);
